module.exports = {"id":"71b48cae-ab26-4a09-bca7-0414730f3568","name":"buyer-acquisition-servicing-advisors","items":[{"name":"advisor-name","type":"text-field","props":{"required":true,"label":"Servicing Advisor''s Name","width":12},"id":"085ea95f-e46c-4863-b485-aad58d739a6c"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer/data_table_forms/acquisition-servicing-advisors.json
// module id = LE80
// module chunks = 0